module.exports = __webpack_public_path__ + "static/media/iconMenu5.72102a88.png";